export const ALL_URL = {
  WECHATSCAN: 'https://h5.ebdan.net/ls/UnHWBLye' // 申请专属物料
}

export const TEXT_PAGE = {
  WECHATSCAN: '申请专属物料'
}

export const ResultData = {
  unusedWechat: false, // 未使用微信扫描会员, true:未使用, false:已使用,
  purchaseAdvice: []
}

export const MemberAdviceItems = [
  {
    title: '未使用微信扫码办会员',
    titleUsed: '已申请物料',
    name: 'unusedWechat',
    description: '免费申请专属物料，高效触达客户，复购率提升50%',
    descriptionUsed: '您的专属物料已寄出，可点击查询快递单号',
    btnName: '免费申请',
    btnNameUsed: '快递查询',
    key: 'WECHATSCAN',
    pageUrl: 'https://h5.ebdan.net/ls/UnHWBLye',
    modeType: -1,
    modeTypeText: '免费申请-扫码办会员',
    iconName: 'robot_scan',
    hidden: false,
    navTitle: '小智会员专属物料领取'
  }
]

export const typeInfo = {
  member: {
    1: '新增会员数',
    2: '会员订单数',
    3: '会员销售额',
    4: '会员销售额占比',
    5: '绑定会员数'
  },
  repurchase: {
    1: '复购率',
    2: '复购人数',
    3: '复购销售额'
  },
  market: {
    1: '触达人数',
    2: '点击人数',
    3: '下单人数',
    4: '下单金额',
    5: '点击转化率',
    6: '下单转化率'
  }
}
const material_blue = require('@/assets/material_blue.png')
const material_orange = require('@/assets/material_orange.png')
const material_red = require('@/assets/material_red.png')
export const materialTheme = [
  {
    id: 1,
    name: '基础',
    imgSrc: ''
  },
  {
    id: 2,
    name: '丹阳橙',
    imgSrc: material_orange
  },
  {
    id: 3,
    name: '天晴蓝',
    imgSrc: material_blue
  },
  {
    id: 4,
    name: '嫣然红',
    imgSrc: material_red
  }
]
